const endorsementTransition = {
    START : 'start',

    CREATE : 'create',

    SUBMIT : 'submit',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    REVERT_TO_SUBMITTED : 'revert to submitted',

    MARK_AS_ISSUED : 'mark as issued',

    REVERT_TO_PENDING_ISSUANCE : 'revert to pending issuance',

    APPROVE : 'approve',

    DECLINE : 'decline',

    REOPEN : 'reopen',

    DELETE : 'delete',

    CREATE_POLICY_FORMS : 'create policy forms',

    OPEN : 'open',

    CREATE_ENDORSEMENT_QUOTE : 'create endorsement quote',

    GENERATE_RATING : 'generate rating',

    GENERATE_RATING_ATTACHMENTS : 'generate rating attachments',

    START_PRICING : 'start pricing',

    MODIFY_RATING : 'modify rating',

    MODIFY_PRICING : 'modify pricing',

    REFRESH_QUOTE : 'refresh quote',

    REVIEW_CHANGES : 'review changes'

};

angular.module('gw-um-j2js')
    .constant('endorsementTransition', endorsementTransition);